import React, { useEffect, useState } from 'react';
import { getBannerList, getCategoryList, getHomeCourse,getCourseList,getAdPush,clickAdPush } from '@/services/home';
import { getUserInfo } from '@/services/myself';

import { history } from 'umi';

import Swiper from './components/Swiper';
import CategoryList from './components/CategoryList';
import GridView from './components/GridView';
import HotList from './components/HotList';
import MemberOnlyList from './components/MemberOnlyList';
import StoreBar from './components/StoreBar';
import SearchInput from '@/components/SearchInput';
import { setLoginUser } from '@/utils/login';
import AdDialog from './components/AdDialog';


export default () => {

  const [bannerList, setBannerList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [hotList, setHotList] = useState([]);
  const [memberOnlyList, setMemberOnlyList] = useState([]);
  const [ad, setAd] = useState(null);

  useEffect(() => {
    getUserInfo().then(res => {
      if (res && res.code == 200) {
        setLoginUser(res.data);
      }
    });


    getBannerList().then(res => {
      console.log(res);
      if (res && res.code == 200) {
        setBannerList(res.data);
      }

    });
    getCategoryList({isShow: 1}).then(res => {
      if (res && res.code == 200) {
        setCategoryList(res.data);
      }

    });

    getCourseList({isHot:1,pageSize:4}).then(res => {
      if (res && res.code == 200) {
        setHotList(res.data.list);
      }
    });

    getCourseList({isHaveMemberOnly:1,pageSize:4}).then(res => {
      if (res && res.code == 200) {
        setMemberOnlyList(res.data.list);
      }
    });

    getHomeCourse().then(res => {
      if (res && res.code == 200) {
        setCourseList(res.data);
      }

    })

    let areaCode = window.localStorage.getItem('areaCode');
    let param = {};
    if (areaCode) {
      param.areaCode = areaCode;
    }
    getAdPush(param).then(res => {
      console.log(res);
      if (res && res.code == 200) {
        if (res.data) {
          setAd(res.data);
        }else {
          setAd(null);
        }
      }
    });

  }, []);

  return (
    <div>

      <SearchInput placeholder={'请输入您想要查询的课程名称或内容'} disable onClick={()=> {
        history.push('/home/search');
      }}/>


      <Swiper bannerList={bannerList} />

      <GridView items={categoryList}/>

      {/*<StoreBar/>*/}

      <MemberOnlyList dataList={memberOnlyList}/>

      <HotList dataList={hotList}/>

      <CategoryList dataList={courseList} />


      <AdDialog isShow={ad  !== null}
                ad={ad}
                closeCallback={()=>{
                 setAd(null);
                }}
                confirmClick={()=>{
                 clickAdPush({pushLogId:ad.pushLogId}).then(res => {
                    setAd(null);
                    window.location.href = ad.url;
                  });

               }}/>

    </div>
  );
}
